import { NgModule } from '@angular/core';
import {CommonModule, DatePipe, isPlatformServer} from '@angular/common';

//import guards
import { ManagerGuard } from './guards/manager.guard';
import { AdminGuard } from './guards/admin.guard';
import { VisitorGuard } from './guards/visitor.guard';

//import services
import { AuthService } from './auth/auth.service';
import {EventGuard} from "./guards/event-guard.guard";
import {FonctionUtiles} from "../fo/fonctionsUtiles";
import {FoEventsService} from "../fo/event/foevents.service";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {EventsService} from "../bo/events/events.service";
import {AccountService} from "../fo/account/account.service";
import {BrowserTransferStateModule, TransferState} from "@angular/platform-browser";
import {TranslateUniversalLoader} from "../shared/universal-translate-loader";
import {TransferHttpCacheModule} from "@nguniversal/common";
import {translateBrowserLoaderFactory} from "../translate-browser.loader";
import {HttpClient} from "@angular/common/http";
import {UserGuard} from "./guards/user.guard";

/*export function createTranslateLoader(http: HttpClient) {
  // We may need a new loader? To define the folder where i18n's files are, and the extension
  return new LazyTranslateHttpLoader(http, './assets/i18n/', '.json');
}*/

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [
    AuthService,
    FoEventsService,
    AccountService,
    EventGuard,
    ManagerGuard,
    VisitorGuard,
    AdminGuard,
    FonctionUtiles,
    EventsService,
    DatePipe,
    UserGuard
  ],
  exports: [
    CommonModule,
    TranslateModule,

  ],
})
export class CoreModule {

}
